module.exports = __webpack_public_path__ + "img/screen9.cb5bf1d.png";